module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 3
// module chunks = 0